<template>
  <div>
    <div class="search-container">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </div>
    <TableRefresh 
      :state="loading"
      @click.native="getRequestsForCurrentUser"
    />
    <v-data-table
      :items="files"
      :headers="headers"
      :loading="loading"
      :search="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      item-key="file_request_id"
      loading-text="Loading... Please wait"
      class="elevation-1 admin-table"
    >
      <template v-slot:item.description="{ item }">
        <v-layout>
          {{ formatDate(item.description) }}
        </v-layout>
      </template>
      <template v-slot:item.created_on="{ item }">
        <v-layout>
          {{ formatDate(item.created_on) }}
        </v-layout>
      </template>
      <template v-slot:item.download_logs="{ item }">
        <v-layout justify-center>
          <DownloadButton 
            :item="item"
            :org-id="orgId"
          />
        </v-layout>
      </template>
      <template v-slot:item.delete_file="{ item }">
        <v-layout justify-center>
          <v-icon  
            size="30"
            color="red" 
            @click="toggleDeletePrompt(item)"
          >
            mdi-delete
          </v-icon>
        </v-layout>
      </template>
    </v-data-table>

    <Prompt
			:display="deleteLogConfirm"
			:close-target="'closeDelete'"
			:submit-target="'submitDeleteLog'"
			:title="'Delete Log File'"
			:message="'Are you sure you wish to delete this log file?'"
			:state="deleteLogState" 
			:res="deleteLogRes"
			@closeDelete="toggleDeletePrompt"
			@submitDeleteLog="deleteFile"
		/>
  </div>
</template>

<script>

import {  
  GetDVRFileRequestForUser, 
  DeleteFileRequest 
} from "@/services/file-retrieval.js"

import { mapGetters } from "vuex"

import moment from "moment";

import DownloadButton from './components/DownloadButton.vue';
import TableRefresh from '@/components/general/TableRefresh.vue';
import Prompt from '@/components/general/Prompt.vue';

import { Logger } from "aws-amplify";
const logger = new Logger("Log Files");

export default {
  name: 'LogFiles',
  components: {
    DownloadButton,
    TableRefresh,
    Prompt
  },
  data () {
    return {
      search: '',
      downloading: false,
      loading: true,
      confirmDelete: false,
      downloadDialog: false,
      files: [],
      logFiles: [],
      orgs: [],
      vehicles: [],
      headers: [
        {
          text: 'Vehicle Name',
          value: 'vehicle_name',
          align: 'left'
        },
        {
          text: 'File Name',
          value: 'file_name',
          align: 'left'
        },
        {
          text: 'Requested On',
          value: 'description',
          align: 'left'
        },
        {
          text: 'Last Updated',
          value: 'created_on',
          align: 'left'
        },
        {
          text: 'Download',
          value: 'download_logs',
          align: 'center'
        },
        {
          text: 'Delete File',
          value: 'delete_file',
          align: 'center'
        }
      ],
      sortBy: 'description',
      sortDesc: true,
      deleteLogConfirm: false,
      deleteLogState: false,
      deleteLogRes: null,
      deleteTarget: {}
    }
  },
  computed: {
    ...mapGetters(["orgId", "orgName"]),
  },
  mounted() {
    this.getRequestsForCurrentUser();
  },
  methods: {
    formatDate(date) {
      let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");

      return moment(formattedDate).isValid() ? formattedDate : date;
    },
    toggleDeletePrompt(item) {
      this.deleteLogState = false;
      this.deleteTarget = item;
      this.deleteLogRes = null
      this.deleteLogConfirm = !this.deleteLogConfirm;
    },
    getRequestsForCurrentUser() {
      this.loading = true;
      this.files = [];
      
      GetDVRFileRequestForUser(this.orgId)
      .then(res => {
        res.file_requests.forEach(file => {
          if (!this.files.includes(file) && file.file_type == 'log') {
            this.files.push(file);
          }
        });

        // Finish loading
        this.loading = false;
      })
      .catch(err => {
        logger.info('There was an error...', err);
        this.loading = false;
      })
    },
    async deleteFile() {
      let vehicleID = this.deleteTarget.vehicle_id;
      let deviceID = this.deleteTarget.device_id;
      let fileID = this.deleteTarget.file_request_id;

      DeleteFileRequest(this.orgId, vehicleID, deviceID, fileID)
      .then(res => {
        logger.info('File deleted!', res);
        if (res) {
          this.deleteLogState = true;
          this.deleteLogRes = {
            msg: `Log file deleted`,
            code: 'green'
          };

          this.removeItemFromTable(this.deleteTarget);
        }
        else {
          this.deleteLogState = true;
          this.deleteLogRes = {
            msg: `An error has occurred`,
            code: 'red'
          };
        }
      })
      .catch(err => {
        this.deleteLogState = true;
        this.deleteLogRes = {
          msg: `An error has occurred`,
          code: 'red'
        };
        logger.info('There was an error deleting the file...', err);
      });
    },
    removeItemFromTable(obj) {
      const index = this.files.indexOf(obj);

      if (index > -1) {
        this.files.splice(index, 1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .download-log {
    &:hover {
      cursor: pointer;
    }
  }
  .search-container {
    width: 20em;
    padding-left: 1em;
  }
</style>